import React, { Component } from "react";
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner'

import { authenticationActions } from '../../modules/authentication';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

class PortalAccess extends Component {

    componentDidMount = () => {
        const queryString = this.props.location.search.split("?")[1];
        if (queryString) {
            const params = queryString.split("&");
            let code, encStr;   // code = id, encStr = token
            for (let i = 0; i < params.length; i++) {
                const param = params[i];
                const arrParam = param.split("=");
                if (arrParam[0] === 'code') code = arrParam[1];
                else if (arrParam[0] === 'encStr') encStr = arrParam[1];
            }

            sessionStorage.setItem("portalAccess", "Y"); // 포털을 통한 로그인(portalAccess.js) 시 sessionStorage에 "Y" 저장
            this.props.portalaccess(code, encStr, false);
        } else {
            this.props.history.push("/login");
        }
    }

    render() {
        return (
            <>
                <Loader
                    type="Rings"
                    color="#00BFFF"
                    height={'50%'}
                    width={'50%'}
                    style={{ 'textAlign': 'center', 'marginLeft': 'auto', 'marginRight': 'auto' }}
                />
            </>
        )
    }
}

function mapState(state) {

    return state;
}

const actionCreators = {
    portalaccess: authenticationActions.portalaccess,
};

export default connect(mapState, actionCreators)(PortalAccess);